import Styles from './CompletionModal.module.scss'
import { Modal, useModals } from 'almanac-ui/Modal'
import { Button } from 'blaze-ui/Button'
import { LinkExternal } from 'blaze-ui/icons'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { ACADEMY_PATH } from 'paths'
import { generatePath } from 'react-router-dom'
import { YoutubeEmbed } from 'screens/Academy/components/ObjectiveModal/YoutubeEmbed'

export const CompletionModal = () => {
  const { closeAllModals } = useModals()
  const workspaceId = useCurrentWorkspaceId()

  const gotoAcademy = () => {
    closeAllModals()
    window.open(generatePath(ACADEMY_PATH, { workspaceId }), '_blank')
  }

  return (
    <Modal.Root bodyClassName={Styles.modal} size="sm">
      <Modal.Header>
        <div className={Styles.blaze101}>
          <YoutubeEmbed fullHeight embedId="CP9MVuvBFNI" autoPlay controls />
        </div>
      </Modal.Header>
      <Modal.Content>
        <h3 className={Styles.header}>Master the Superpowers of Blaze</h3>
        <p className={Styles.content}>
          Watch the recording of our Blaze 101 webinar (
          <a href="https://my.demio.com/ref/m3yjidEM28k8gbfw" target="_blank" rel="noreferrer noopener">
            or register for an upcoming live session
          </a>
          ) to learn everything you need to know about how to create, edit, publish, and organize content in Blaze.
          <br />
          <br />
          Find more tips like these by clicking on "Help and Learn Blaze" in the navigation.
        </p>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Button size="lg" variant="tertiary" onPress={closeAllModals}>
            Close
          </Button>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Button size="lg" onPress={gotoAcademy} endIcon={LinkExternal}>
            Explore Blaze Academy
          </Button>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
